import { Loader2, Pencil } from "lucide-react";
import { Link } from "react-router-dom";
import { useSacredPage } from "@/hooks/useSacredPage";
import { UniversalPageRenderer } from "./UniversalPageRenderer";
import { useSacredAdmin } from "@/hooks/useSacredAdmin";
import { Button } from "@/components/ui/button";
import { CmsPageProvider } from "./CmsPageContext";

/**
 * CMS page wrapper.
 * @param {string} slug
 * @param {object} [page] optional preloaded page (from useSacredPage parent)
 * @param {boolean} [loading]
 * @param {'embedded'|'document'} [layout] embedded = labels only in children; document = full renderer
 * @param {React.ReactNode} children
 */
export function CmsPageShell({ slug, page: pageProp, loading: loadingProp, layout = "embedded", children }) {
  const fetched = useSacredPage(slug);
  const page = pageProp ?? fetched.page;
  const loading = loadingProp ?? fetched.loading;
  const { canEditPages } = useSacredAdmin();

  const ctx = { page, loading, slug };

  return (
    <CmsPageProvider value={ctx}>
      <div data-cms-slug={slug} data-cms-layout={layout}>
        {canEditPages && (
          <div className="max-w-6xl mx-auto px-4 pt-20 flex justify-end">
            <Button size="sm" variant="outline" asChild>
              <Link to={`/admin/pages/${slug}/edit`}>
                <Pencil className="w-4 h-4 mr-1" /> Edit page content
              </Link>
            </Button>
          </div>
        )}
        {loading && (
          <div className="flex justify-center py-8">
            <Loader2 className="w-6 h-6 animate-spin text-primary" />
          </div>
        )}
        {!loading && layout === "document" && page && <UniversalPageRenderer page={page} className="py-8 px-4" />}
        {!loading && children != null ? children : null}
      </div>
    </CmsPageProvider>
  );
}
